<template>
  <el-container>
    <el-form ref="passwordForm" :model="ruleForm" label-width="120px" :rules="rules">
      <el-form-item
        label="旧密码"
        style="text-align: left"
        prop="old_pwd">
        <el-input type="password" v-model="ruleForm.old_pwd" show-password />
      </el-form-item>
      <el-form-item
        label="新密码"
        style="text-align: left"
        prop="new_pwd">
        <el-input type="password" v-model="ruleForm.new_pwd" show-password />
      </el-form-item>
      <el-form-item
        label="确认密码"
        style="text-align: left"
        prop="confirm_pwd">
        <el-input
          type="password"
          v-model="ruleForm.confirm_pwd"
          show-password/>
      </el-form-item>
      <el-form-item style="text-align: left;">
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog qd" @click="handleModifyPwd">确认修改</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import loginHelper from '@/api/login_helper'

export default {
  name: '',
  data () {
    return {
      rules: {
        old_pwd: [
          { required: true, message: '请输入旧的密码', trigger: 'blur' },
          {
            pattern: /^[\w]{6,12}$/,
            message: '密码的格式为6-12位，只能是字母、数字和下划线'
          }
        ],
        new_pwd: [
          { required: true, message: '请输入新的密码', trigger: 'blur' },
          {
            pattern: /^[\w]{6,12}$/,
            message: '密码的格式为6-12位，只能是字母、数字和下划线'
          }
        ],
        confirm_pwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          {
            pattern: /^[\w]{6,12}$/,
            message: '密码的格式为6-12位，只能是字母、数字和下划线'
          }
        ]
      }
    }
  },

  props: ['ruleForm'],

  methods: {
    handleModifyPwd () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          if (this.ruleForm.new_pwd !== this.ruleForm.confirm_pwd) {
            this.$message.error('新密码与确认密码不一致')
            return
          }
          Backend.post(this, '/user/modify_pwd', {
            old_pwd: this.ruleForm.old_pwd,
            new_pwd: this.ruleForm.new_pwd
          }).then(() => {
            this.$message.success('密码修改成功, 请重新登录!')
            loginHelper.logout(this)
          })
        }
      })
    }
  }
}
</script>
